import React from 'react';
import classnames from 'classnames';
import { Section } from '@fiverr-private/fit';
import { MixpanelContextProvider } from './context/MixpanelContext';
import { CollectionsContextProvider } from './context/CollectionsContext';
import { BigQuery } from './BigQuery';
import { PageViewTracker } from './PageViewTracker';
import { FeaturedSubCategory } from './FeaturedSubCategory';
import { Details } from './Details';
import { MediaPreview } from './MediaPreview';
import { RecommendationsCarousel } from './RecommendationsCarousel';
import { RecommendationsGrid } from './RecommendationsGrid';
import { ImpressionableInitializer } from './ImpressionableInitializer';
import type { InspireDeliveryPageProps } from './types';

import classes from './InspireDeliveryPage.module.scss';

export const InspireDeliveryPage = ({ inspireDelivery }: InspireDeliveryPageProps) => {
  const id = inspireDelivery.id;
  const deliveredDate = inspireDelivery.deliveredDate;
  const categoryId = inspireDelivery.category.categoryId;
  const subCategoryId = inspireDelivery.category.subCategoryId;
  const nestedSubCategoryId = inspireDelivery.category.nestedCategoryId;
  const buyerUserName = inspireDelivery.buyer.name;
  const sellerId = inspireDelivery.seller.id;
  const sellerUserName = inspireDelivery.seller.user.name;
  const sellerOneLinerTitle = inspireDelivery.seller.oneLinerTitle;
  const sellerAvatarUrl = inspireDelivery.seller.user.profileImageUrl;
  const gigId = inspireDelivery.gig.id;
  const gigSlug = inspireDelivery.gig.slug;
  const itemType = inspireDelivery.originalDeliveryAttachment.type;
  const isVideo = itemType === 'VIDEO';
  const src = isVideo
    ? (inspireDelivery.originalDeliveryAttachment.mediaUrl as string)
    : inspireDelivery.originalDeliveryAttachment.largePreviewUrl.url;

  return (
    <MixpanelContextProvider
      deliveryId={id}
      gigId={gigId}
      sellerId={sellerId}
      itemType={itemType}
      subCategoryId={subCategoryId}
    >
      <BigQuery
        deliveryId={id}
        deliveryAttachmentType={itemType}
        gigId={gigId}
        sellerId={sellerId}
        categoryId={categoryId}
        subCategoryId={subCategoryId}
        nestedSubCategoryId={nestedSubCategoryId}
      >
        <CollectionsContextProvider>
          <ImpressionableInitializer />
          <PageViewTracker />
          <Section className={classes.root}>
            <main className={`${classes.main} m-b-24`}>
              <FeaturedSubCategory id={subCategoryId} />
              <MediaPreview id={id} isVideo={isVideo} src={src} />
              <Details
                deliveryId={id}
                deliveredDate={deliveredDate}
                buyerUserName={buyerUserName}
                sellerUserName={sellerUserName}
                sellerAvatarUrl={sellerAvatarUrl}
                sellerOneLinerTitle={sellerOneLinerTitle}
                gigSlug={gigSlug}
              />
            </main>
            <div className={classes.divider} />
            <div className={classes.block}>
              <RecommendationsCarousel inspireDeliveryId={id} subCategoryId={subCategoryId} />
            </div>
            <div className={classes.divider} />
            <div className={classnames(classes.block, classes.blockTopIncreased)}>
              <RecommendationsGrid inspireDeliveryId={id} />
            </div>
          </Section>
        </CollectionsContextProvider>
      </BigQuery>
    </MixpanelContextProvider>
  );
};
